import Quill from '../core/quill';
import Module from '../core/module';
import Figure from '../formats/figure';
import icons from '../ui/icons';
import extend from 'extend';

// const BINDINGS = {};

class FigureModule extends Module {
  static register() {
    Quill.register(Figure);
  }
  
  constructor(quill, options) {
    options = extend({}, {
      buttons: true,
      caption: true,
    }, options);
    
    super(quill, options);
  
    this.container = document.createElement('div');
    this.initSelection();
    if (this.options.buttons) {
      this.initButtons();
    }
    // this.addKeyboardBindings();
  }
  
  // addKeyboardBindings() {
  //   Object.keys(BINDINGS).forEach(name => {
  //     this.quill.keyboard.addBinding(BINDINGS[name]);
  //   });
  // }
  
  initButtons() {
    const buttons = [
      {key: 'left', icon: icons.interfacePack.align.left, class: 'float-left col-md-6'},
      {key: 'center', icon: icons.interfacePack.align.center, class: 'text-center'},
      {key: 'right', icon: icons.interfacePack.align.right, class: 'float-right col-md-6'}
    ];
  
    for (const btn of buttons) {
      const el = document.createElement('BUTTON');
      el.setAttribute('type', 'button');
      el.innerHTML = btn.icon;
    
      el.addEventListener('click', () => {
        const active = el.parentNode.querySelector('.active');
        active && active.classList.remove('active');
        el.classList.add('active');
      
        let range = this.quill.getSelection();
        let [block] = this.quill.scroll.descendant(Figure, range.index);
        block.domNode.className = btn.class;
      });
    
      this.container.appendChild(el);
    }
  
    this.quill.container.appendChild(this.container);
    
    this.container.classList.add('ql-figure-tooltip');
    this.container.classList.add('ql-hidden');
    this.container.style.position = 'absolute';
    this.controls = [];
  
    window.addEventListener('resize', this.hideTooltip.bind(this));
  
    setTimeout(this.hideTooltip.bind(this), 0);
  }
  
  initSelection() {
    this.quill.on(Quill.events.EDITOR_CHANGE, (type, range) => {
      if (type === Quill.events.SELECTION_CHANGE) {
        this.update(range);
      }
    });
  }
  
  blocksUpdatePosition(range) {
    range = range ? range : this.quill.getSelection();
    const lineBounds = this.quill.getBounds(range);
    this.container.style.left = '50%';
    this.container.style.top = (lineBounds.top + 5) + 'px';
    this.container.style.marginLeft = '-'+(this.container.clientWidth / 2)+'px';
  }
  
  checkFigureBlots(range) {
    let [embed,] = this.quill.scroll.descendant(Figure, range.index);
    let embeds = this.quill.scroll.descendants(Figure, 0, this.quill.scroll.length());
    embeds.forEach((blot) => {
      if (embed !== blot) {
        blot.blur();
      }
    });
    if (embed) {
      embed.focus();
    }
  }
  
  showTooltip(range) {
    // console.log('SHOW FIGURE TOOLTIP');
    this.container.classList.remove('ql-hidden');
    this.blocksUpdatePosition(range);
  }
  
  hideTooltip() {
    // console.log('HIDE FIGURE TOOLTIP');
    this.container.classList.add('ql-hidden');
  }
  
  update(range) {
    if (!this.quill.isEnabled()) return;
    if (range === null) return;
    
    this.checkFigureBlots(range);
  }
}

export default FigureModule;
